var endpointMap = {
	en: {
		translations: "translation-en.json"
	},
	"en-GB": {
		translations: "translation-en.json"
	},
	"en-US": {
		translations: "translation-en.json"
	},
	und: {
		translations: "translation.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
